module.exports = __webpack_public_path__ + "static/media/RESULTSNOTINYET.846660fb.svg";